module.exports = __webpack_public_path__ + "img/SCG.ad2668f1.jpg";